export const DEFAULT_NOTE_NAME = "New Note";